import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printingA4billing',
  templateUrl: './printingA4billing.component.html',
  styleUrls: ['./printingA4billing.component.css']
})
export class PrintingA4billingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
